import React, {useEffect, useState} from "react";
import {
	AdminSharedRestControllerApiFactory,
	Person,
	SharedPerson,
	SupportGroup,
	SupportLink,
	SupportLinkList,
	SupportLinkRestControllerApiFactory
} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {useForm} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Box, Button, Grid, List, ListItemButton, TextField, Typography} from "@mui/material";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";


export const SupportLinkEditPage = () => {

	const apiManager = useApiManager();
	
	const ctrl = apiManager.factory(SupportLinkRestControllerApiFactory);
	// Del controlador compartido: compliance no abre la ficha de personal de RR. HH. (#13899)
	const personCtrl = apiManager.factory(AdminSharedRestControllerApiFactory);

	const [people, setPeople] = useState<SharedPerson[]>([]);
	const [peopleFiltered, setPeopleFiltered] = useState<SharedPerson[]>([]);
	const [peopleSelected, setPeopleSelected] = useState<SharedPerson[]>([]);
	const [personFilter, setPersonFilter] = useState<string>('');
	const [showGroups, setShowGroups] = useState<boolean>(false);

	const form = useForm<SupportLink>({
		fetcher: (id) => ctrl.getSupportLink(id),
		updater: (bean) => ctrl.saveSupportLink(bean),
		remover: (id) => ctrl.deleteOrDismissSupportLink(id),
		factory: () => {
			return {
				name: '',
			} as SupportLink;
		},
		postLoad: t => {
			const selected = [] as SharedPerson[];
			(t.group || []).forEach(pg => {
				selected.push(pg.person);
			});
			setPeopleSelected(selected);
			setShowGroups(t.id != undefined);
		},
		preUpdate: bean => {
			const groups = [] as SupportGroup[];
			peopleSelected.forEach(p => {
				groups.push({
					person: {id: p.id} as Person,
					supportLink: {id: bean.id} as SupportLinkList
				} as SupportGroup);
			});
			bean.group = groups;
			return true;
		},
		postUpdate: bean => {
			setShowGroups(bean.id != undefined);
		}
	});

	useEffect(() => {
		personCtrl.retrievePeople().then(resp => setPeople(resp.data))
	}, []);

	useEffect(() => {
		const p = people.filter(p => (p.surnamesAndName || '').toUpperCase().indexOf(personFilter.toUpperCase()) >= 0);
		setPeopleFiltered(p);
	}, [personFilter, people]);


	return (
		<>
			<FormContent form={form} title={"Ficha de enlace a evaluación"}>

				<Box sx={{my: 2}}>
					<Button variant="outlined" size="small" endIcon={<OpenInNewRoundedIcon/>}
							href={"/evaluation?t=" + (form.value("token") || "")} disabled={!form.value("token")} target="_blank" rel="noreferrer">
						Abrir el formulario de valoración
					</Button>
				</Box>

				<Grid container spacing={3}>
					<Grid item xs={12} sm>
						<FormInput
							field={"name"}
							type={"text"}
							label={"Nombre del enlace"}/>
					</Grid>
					<Grid item xs={12} sm>
						<FormInput
							field={"evaluationDate"}
							type={"datetime"}
							label={"Fecha de la evaluación"}
						/>
						<small>Se cumplimentará automáticamente desde el enlace</small>
					</Grid>
				</Grid>


				{showGroups && (
					<Box sx={{mt: 5}}>
						<Typography sx={{fontWeight: "bold", fontSize: "1.2em"}}>Personas solicitadas</Typography>
						<TextField variant="filled"
								   fullWidth
								   label={"Filtro"}
								   sx={{pb: 2}}
								   value={personFilter}
								   onChange={e => setPersonFilter(e.target.value)}
						/>

						<Grid container spacing={2}>

							<Grid item xs={6}>
								<Typography sx={{fontWeight: "bold"}}>Disponibles</Typography>
								<List sx={{maxHeight: "20em", overflowY: "auto", border: "1px solid gray;"}}>
									{peopleFiltered && peopleFiltered.map((person, i) => (
										<ListItemButton
											key={"person-" + i}
											onClick={() => {
												const f = peopleSelected.find(p => p.id == person.id);
												if (!f) {
													const newArr = [...peopleSelected];
													newArr.push(person);
													const ordered = newArr.sort((a, b) => (a.surnamesAndName as string).localeCompare(b.surnamesAndName as string))
													setPeopleSelected(ordered);
												}
											}}>
											{person.surnamesAndName}
										</ListItemButton>
									))}
								</List>

							</Grid>
							<Grid item xs={6}>
								<Typography sx={{fontWeight: "bold"}}>Seleccionados</Typography>
								<List>
									{peopleSelected && peopleSelected.map((person, i) => (
										<ListItemButton
											key={"selected-" + i}
											onClick={() => {
												const newArr = [...peopleSelected].filter(p => p.id != person.id);
												setPeopleSelected(newArr);
											}}>
											{person.surnamesAndName}
										</ListItemButton>
									))}
								</List>
							</Grid>
						</Grid>

					</Box>
				)}


			</FormContent>
		</>
	);
};
